import { env } from '@/env'
import { api } from '@/services/fintalk/api'

import { type AuthTokens } from './types'

export interface LoginParams {
  email: string
  password: string
}

export async function login({
  email,
  password,
}: LoginParams): Promise<AuthTokens> {
  const resp = await api.post<AuthTokens>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    '/login',
    {
      body: { email, password },
    },
  )

  return resp.body
}
